module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"BranchBox":{"link":"Více informací o prodejně"}},"en":{"BranchBox":{"link":"More information about the store"}}}')
  delete Component.options._Ctor
}
